module.exports = __webpack_public_path__ + "img/suit-1.389ce91c.jpg";